import React from "react";

function EventStatistics() {
  return <>Statistics</>;
}

export default EventStatistics;
